import React from "react";
import { packClasses } from "Utils";

function Toolbar(props) {
    return (
        <div className="relative">
            <div
                className={packClasses(
                    "mb-4 flex items-center justify-items-start divide-x divide-gray-400 overflow-x-auto rounded bg-white py-2 pr-2 shadow md:overflow-visible",
                    props.className
                )}
            >
                {props.children}
            </div>
            <div
                className="absolute h-full w-2 bg-gradient-to-r from-gray-400 sm:hidden"
                style={{ top: 0, left: 0 }}
            />
            <div
                className="absolute h-full w-2 bg-gradient-to-l from-gray-400 sm:hidden"
                style={{ top: 0, right: 0 }}
            />
        </div>
    );
}

export default Toolbar;

export const ToolbarGroup = (props) => {
    return (
        <div
            className={packClasses(
                "mx-1 flex pl-2",
                props.className ? props.className : ""
            )}
        >
            {props.children}
        </div>
    );
};
